import { render, staticRenderFns } from "./watermeterDetail.vue?vue&type=template&id=e835928a&scoped=true"
import script from "./watermeterDetail.vue?vue&type=script&lang=js"
export * from "./watermeterDetail.vue?vue&type=script&lang=js"
import style0 from "./watermeterDetail.vue?vue&type=style&index=0&id=e835928a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e835928a",
  null
  
)

export default component.exports